var _line, _line2, _polyline, _polyline2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeVsExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 270,
    x2: 550,
    y2: 270,
    stroke: "#CBD5E1",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 110,
    x2: 550,
    y2: 110,
    stroke: "#E2E8F0",
    strokeWidth: 2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "90,220 170,200 250,180 330,140 410,150 490,120 550,110",
    fill: "none",
    stroke: "#2563EB",
    strokeWidth: 4
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "90,240 170,230 250,210 330,200 410,190 490,200 550,210",
    fill: "none",
    stroke: "#F97316",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 180,
    r: 5,
    fill: "#2563EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 210,
    r: 5,
    fill: "#F97316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeVsExpense);
export default __webpack_public_path__ + "static/media/income-vs-expense.eac65d21528a83265c66509957901d06.svg";
export { ForwardRef as ReactComponent };